import DESI from './desi';
import ITALIAN from './italian';
import SOUTHINDIAN from './southIndian';
import PIZZA from './pizza';
import INDIANSNACKS from './indianSnacks';
import PLANTBASED from './plantbased';
import SPECIALITEM from './specialmenu';

const MENUDATA = {
  "desi-flavour": DESI,
  "italian": ITALIAN,
  "south-indian": SOUTHINDIAN,
  "pizza":PIZZA,
  "indian-snacks": INDIANSNACKS,
  "plantbased": PLANTBASED,
  "special-item": SPECIALITEM
}

export default MENUDATA;